export default __webpack_public_path__ + "static/media/tablecloth.0bd58040.png";